import React from 'react';
import { Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';
import './App.css';
import 'antd/dist/antd.css';
import { BreakpointProvider } from 'react-socks';
import PmApp from './apps/PmApp';
// import TestApp from './apps/TestApp';
import PPDPage from './containers/PPD/PPDPage';
import { store } from './store/store';

const history = createBrowserHistory();

function App() {
  return (
    <BreakpointProvider>
      <Provider store={store}>
        <Route
          exact
          path={[
            '/',
            '/pm',
            '/auto',
          ]}
          children={<PmApp/>}
        />
        {/* <Route exact path={[ */}
        {/*    '/ppd/shape/:startDate/:endDate/:intersectionTimezone/:position/:direction/:movement/:flow/:selectedDaysOfWeek/:todStart/:todEnd/:sf/:dsb/:lat/:long', */}
        {/* ]} children={<PPDPage pmType='shape'/>}/> */}
        <Route
          exact
          path={[
            '/ppd/:startDate/:endDate/:timezone/:intersectionId/:intersectionName/:direction/:movement/:selectedDaysOfWeek/:todStart/:todEnd/:lat/:long',
          ]}
          children={<PPDPage/>}
        />
        {/* <Route exact path = {[
                            '/testPage',
                          ]} children={<TestApp/>}/> */}
      </Provider>
    </BreakpointProvider>
  );
}

export default App;
